/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import LivingRoom from "../../Attachments/Images/IntroSectImage.png";

var sliderComponent = [
  <div
    className={`w-100 grid place-items-center bg-white py-7 px-4 lg:px-6 rounded-2xl`}
  >
    <img src={LivingRoom} className="h-52 md:h-64"></img>
    <ul className="list-none space-y-5 text-center my-10">
      <li>
        <h1 className="font-Poppins font-medium text-2xl lg:text-3xl xl:text-4xl">
          Imagination
        </h1>
      </li>
      <li>
        <h1 className="font-Poppins font-normal text-sm sm:text-base md:text-xl">
          Share your design to us and let us make it happen
        </h1>
      </li>
    </ul>
  </div>,
  <div
    className={`w-100 h-auto grid place-items-center bg-white py-6 px-4 lg:px-6 rounded-xl`}
  >
    <img src={LivingRoom} className="h-52 md:h-64"></img>
    <ul className="list-none space-y-5 text-center my-10">
      <li>
        <h1 className="font-Poppins font-medium text-2xl lg:text-3xl xl:text-4xl">
          Best Experience
        </h1>
      </li>
      <li>
        <h1 className="font-Poppins font-normal text-sm sm:text-base md:text-xl">
          We give meaning for your better home living and natural inspiration in
          every room
        </h1>
      </li>
    </ul>
  </div>,
  <div
    className={`w-100 h-auto grid place-items-center bg-white py-6 px-4 lg:px-6 rounded-xl`}
  >
    <img src={LivingRoom} className="h-52 md:h-64"></img>
    <ul className="list-none space-y-5 text-center my-10">
      <li>
        <h1 className="font-Poppins font-medium text-2xl lg:text-3xl xl:text-4xl">
          Modern Interior
        </h1>
      </li>
      <li>
        <h1 className="font-Poppins font-normal text-sm sm:text-base md:text-xl">
          We will help you to make an elegant and luxurious interior designed by
          professional interior designer
        </h1>
      </li>
    </ul>
  </div>,
];

export default sliderComponent;
